var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',_vm._b({attrs:{"value":_vm.overlay}},'v-overlay',_vm.options.overlayProps,false),[_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.options.spinnerProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }